import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeaderTablePage = ({ title, addText, addLink, id, withDownloadPdfCallback, withDownloadExcelCallback, ...props }) => {
  const { t } = useTranslation();
  const [loadDownloadPdf, setLoadDownloadPdf] = useState(false);
  const [loadDownloadExcel, setLoadDownloadExcel] = useState(false);
  return (
    <div id={id || ""} className="kt-portlet__head kt-portlet__head--lg">
      <div className="kt-portlet__head-label">
        <span className="kt-portlet__head-icon">
          <i className="kt-font-brand flaticon2-line-chart" />
        </span>
        <h3 className="kt-portlet__head-title">{title}</h3>
      </div>
      {((addLink  && addText) || withDownloadPdfCallback || withDownloadExcelCallback) && (
        <div className="kt-portlet__head-toolbar">
          <div className="kt-portlet__head-wrapper">
            &nbsp;
            {addLink && addText && (
              <div className="dropdown dropdown-inline">
                <Link to={addLink} className="btn btn-brand btn-icon-sm">
                  <i className="flaticon2-plus" /> {addText}
                </Link>
              </div>
            )}
            {withDownloadPdfCallback && (
              <button
                onClick={() => {
                  setLoadDownloadPdf(true);
                  withDownloadPdfCallback().finally(() => {
                    setLoadDownloadPdf(false);
                  });
                }}
                disabled={loadDownloadPdf || props.loading}
                className="btn btn-secondary ml-3"
              >
                {loadDownloadPdf ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    {t("Chargement...")}
                  </>
                ) : (
                  <>
                    <i className="la la-download" /> {t("Télécharger PDF")}
                  </>
                )}
              </button>
            )}

            {withDownloadExcelCallback && (
              <button
                onClick={() => {
                  setLoadDownloadExcel(true);
                  withDownloadExcelCallback().finally(() => {
                    setLoadDownloadExcel(false);
                  });
                }}
                disabled={loadDownloadExcel || props.loading}
                className="btn btn-secondary ml-3"
              >
                {loadDownloadExcel ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    {t("Chargement...")}
                  </>
                ) : (
                  <>
                    <i className="la la-download" /> {t("Télécharger Excel")}
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderTablePage;
